
<div class="row">
  <div class="col">
    <h4>
      Histórico
      <small class="text-muted">(#ID: {{ historico.id }})</small>
    </h4>
  </div>

  <div class="col-auto">
    <button type="button" class="btn btn-primary" (click)="fecharHistorico()"> Fechar Histórico</button>
  </div>

</div>


<div class="row">
  <ul ngbNav #nav="ngbNav" class="col nav-tabs">
    <li [ngbNavItem]="'dados-basicos'" id="dados-basicos" title="Dados Básicos">
        <button ngbNavLink>Dados Básicos</button>
        <ng-template ngbNavContent>
            <div class="row">

                <div class="bn-form-group col-md-3">
                    <label><b>Data do histórico</b></label>
                    <bn-datepicker name="dataCriacao" [(ngModel)]="historico.dataCriacao" disabled>
                    </bn-datepicker>
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>Usuário responsável</b></label>
                    <input class="form-control" name="nome" [(ngModel)]="historico.usuarioResponsavel" disabled>
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>Número da cesta</b></label>
                    <input class="form-control" name="numeroTranche" [(ngModel)]="historico.numeroTranche" disabled />
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>Tipo cálculo limite</b></label>
                    <input *ngIf="!modoEdicao" class="form-control" name="tipoCalculoLimite"
                        [(ngModel)]="historico.idTipoCalculoLimite" disabled />
                </div>

            </div>

            <div class="row">

                <div class="bn-form-group col-md-3">
                    <label><b>Data início contratação</b></label>
                    <bn-datepicker name="dataInicioContratacao" [(ngModel)]="historico.dataInicioContratacao" disabled>
                    </bn-datepicker>
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>Data fim contratação</b></label>
                    <bn-datepicker name="dataFimContratacao" [(ngModel)]="historico.dataFimContratacao" disabled>
                    </bn-datepicker>
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>Data início protocolo</b></label>
                    <bn-datepicker name="dataInicioProtocolo" [(ngModel)]="historico.dataInicioProtocolo" disabled>
                    </bn-datepicker>
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>Data fim protocolo</b></label>
                    <bn-datepicker name="dataFimProtocolo" [(ngModel)]="historico.dataFimProtocolo" disabled>
                    </bn-datepicker>
                </div>

            </div>

            <div class="row">

                <div class="bn-form-group col-md-3">
                    <label><b>Data fim liberação</b></label>
                    <bn-datepicker name="dataFimLiberacoes" [(ngModel)]="historico.dataFimLiberacoes" disabled>
                    </bn-datepicker>
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>Data fim retificação</b></label>
                    <bn-datepicker name="dataFimRetificacoes" [(ngModel)]="historico.dataFimRetificacoes" disabled>
                    </bn-datepicker>
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>Data início Cobranca Ecg</b></label>
                    <bn-datepicker name="dataInicioCobrancaEcg" [(ngModel)]="historico.dataInicioCobrancaEcg" disabled>
                    </bn-datepicker>
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>Data fim Cobranca Ecg</b></label>
                    <bn-datepicker name="dataFimCobrancaEcg" [(ngModel)]="historico.dataFimCobrancaEcg" disabled>
                    </bn-datepicker>
                </div>

            </div>

            <div class="row">

                <div class="bn-form-group col-md-3">
                    <label><b>Qtde. dias limite retificação</b></label>
                    <input min="0" class="form-control" name="quantidadeDiasLimiteRetificacao"
                        [(ngModel)]="historico.quantidadeDiasLimiteRetificacao" bnMask="INTEIRO" disabled />
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>Qtde. dias limite aditivo</b></label>
                    <input min="0" class="form-control" name="quantidadeDiasLimiteAditivo"
                        [(ngModel)]="historico.quantidadeDiasLimiteAditivo" bnMask="INTEIRO" disabled />
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>Faturamento mínimo</b></label>
                    <input class="form-control" name="valorFaturamentoMaximo" bnMask="MOEDA"
                        [(ngModel)]="historico.valorFaturamentoMinimo" disabled />
                </div>

                <div class="bn-form-group col-md-3">
                    <label><b>Faturamento máximo</b></label>
                    <input class="form-control" name="valorFaturamentoMaximo" bnMask="MOEDA"
                        [(ngModel)]="historico.valorFaturamentoMaximo" disabled />
                </div>

            </div>

            <div class="row">

                <div class="bn-form-group col-md-3">
                    <label><b>Valor crédito mínimo</b></label>
                    <input class="form-control" bnMask="MOEDA" name="valorCreditoMinimo"
                        [(ngModel)]="historico.valorCreditoMinimo" disabled />
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>Valor limite total do beneficiário</b></label>
                    <input class="form-control" name="valorLimiteTotalBeneficiario" bnMask="MOEDA"
                        [(ngModel)]="historico.valorLimiteTotalBeneficiario" disabled />
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>Prazo carência mínimo (meses)</b></label>
                    <input min="0" class="form-control" name="quantidadeMesesPrazoMinimoCarencia"
                        [(ngModel)]="historico.quantidadeMesesPrazoMinimoCarencia" bnMask="INTEIRO" disabled />
                </div>

                <div class="bn-form-group col-md-3">
                    <label><b>Prazo carência máximo (meses)</b></label>
                    <input class="form-control" name="quantidadeMesesPrazoMaximoCarencia"
                        [(ngModel)]="historico.quantidadeMesesPrazoMaximoCarencia" bnMask="INTEIRO" disabled />
                </div>

            </div>

            <div class="row">

                <div class="bn-form-group col-md-3">
                    <label><b>Prazo total mínimo (meses)</b></label>
                    <input class="form-control" name="quantidadeMesesPrazoMinimoTotal"
                        [(ngModel)]="historico.quantidadeMesesPrazoMinimoTotal" bnMask="INTEIRO" disabled />
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b>Prazo total máximo (meses)</b></label>
                    <input class="form-control" name="quantidadeMesesPrazoMaximoTotal"
                        [(ngModel)]="historico.quantidadeMesesPrazoMaximoTotal" bnMask="INTEIRO" disabled />
                </div>
                <div class="bn-form-group col-md-3">
                    <label><b> % garantido emb. taxa stop loss </b>
                        <i class="fa fa-question-circle help-subtitulo" placement="top-right" ngbTooltip="
               Indica se o percentual garantido está embutido na taxa de Stop Loss"></i></label>
                    <input class="form-check checkbox-gigante" type="checkbox"
                        name="percentualGarantidoEmbutidoTaxaStopLoss"
                        [(ngModel)]="historico.percentualGarantidoEmbutidoTaxaStopLoss" disabled />
                </div>

                <div class="bn-form-group col-md-3">
                    <label><b> Indicador aditivo habilitado</b> </label>
                    <input class="form-check checkbox-gigante" type="checkbox" name="indicadorAditivoHabilitado"
                        [(ngModel)]="historico.indicadorAditivoHabilitado" disabled />
                </div>

            </div>

            <div class="row">

                <div class="bn-form-group col-md-3">
                    <label><b> Lim. especial habilitado&ensp;</b>
                        <i class="fa fa-question-circle help-subtitulo" placement="top-right" ngbTooltip="
               Indica se a tranche tem previsão de limite especial"></i></label>
                    <input class="form-check checkbox-gigante" type="checkbox"
                        name="indicadorLimiteEspecialHabilitado"
                        [(ngModel)]="historico.indicadorLimiteEspecialHabilitado" disabled>
                </div>

            </div>

        </ng-template>
    </li>
  </ul>

  <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
